import React from 'react';

import './Footer.scss'

export default class Footer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: ''
        }
    }

    render() {
        return (
            <footer className="text-center">
                <span>
                    <strong>
                        This website was created by
                        <a href="https://philb.dev"> <strong>philb.dev</strong></a>
                    </strong>
                </span>
            </footer>
        )
    }

}
